import React from 'react';
import styled from '@emotion/styled'
import { css, keyframes } from '@emotion/core';

import { Grid, lineHeight, MixBlendDifference, MixBlendText, responsiveFontSize, zIndexes } from 'style';

const HeroTextComponent = ({
    title,
    titleForMobileDevices,
    disableDifferenceEffect,
    color }) => {
    return (
        <HeroFront id="HeroText"
            disableDifferenceEffect={disableDifferenceEffect}>
            <div className="wrapper">
                <div className="container-fluid" css={container_css}>
                    <div className="row" css={row_css}>
                        <div className="col-xs-12">
                            <HeroTextWrapper
                                disableDifferenceEffect={disableDifferenceEffect}
                                color={color && color.hex}>
                                <HeroText>{title}</HeroText>
                                <HeroTextForMobiles>{titleForMobileDevices ? titleForMobileDevices : title}</HeroTextForMobiles>
                            </HeroTextWrapper>
                        </div>
                    </div>
                </div>
            </div>
        </HeroFront>
    );
};
const HeroTextWrapperAnim = keyframes`
0%{
  opacity: 0;
  transform: translateY(40px);
}
100%{
  opacity: 1;
  transform: translateY(0px);
}
`;
const container_css = css`
    height: 70%;
    align-self: center;

    @media (min-width: 500px) {
        height: 70%;
    }
`;
const row_css = css`
    height: 100%;
`;
const HeroTextWrapper = styled.div`
    color: ${props => (props.disableDifferenceEffect ? props.color : '')};
    ${props => !props.disableDifferenceEffect && MixBlendText({})};
    height: 100%;
    width: 100%;

    display: flex;
    align-items: flex-end;
    font-family: 'TomoSlab';
    font-weight: 100;

    * {
    font-weight: 100;
    }
`;

const HeroText = styled.h1`

    // ${responsiveFontSize(32, 48)};
    // line-height: 1.5;
    white-space: pre-line;

    margin: 0;
    font-weight: 300;
    opacity: 0;
    transform: translateY(40px);
    animation: ${HeroTextWrapperAnim} 1s 0.2s forwards;
    @media(max-width: 799px){
      display: none;
    }
`;

const HeroTextForMobiles = styled.div`
    font-size: 27px;
    line-height: 34px;
    white-space: pre-line;

    margin: 0;
    font-weight: 300;
    opacity: 0;
    transform: translateY(40px);
    animation: ${HeroTextWrapperAnim} 1s 0.2s forwards;
    @media(min-width: 800px){
      display: none;
    }
    // padding-bottom: 10vw;
`;

const HeroFront = styled.div`
    ${props => !props.disableDifferenceEffect && MixBlendDifference};
    width: 100%;
    height: 100%;
    pointer-events: none;
    
    position: absolute;
    z-index: ${zIndexes.zHero + 1};

    .wrapper{
        height: 100%;
        align-items: flex-end;
        display: flex;
    }
`;

export default HeroTextComponent;
